<template>
  <div>
    <el-radio-group style="padding: 10px 5px" v-model="activeName" @change="handleChange" size="medium">
      <el-radio-button v-permission="'ensure_income__list'" label="全案保量" name="order"/>
      <el-radio-button v-permission="'business_income__list'" label="商务收入" name="regular"/>
      <el-radio-button v-permission="'income_summary_v2__list'" label="收入汇总V2" name="isv2"/>
    </el-radio-group>
    <income-ensure v-if="activeName==='全案保量'"></income-ensure>
    <income-business v-if="activeName==='商务收入'"></income-business>
    <income-summary-v2 v-if="activeName==='收入汇总V2'"></income-summary-v2>

  </div>
</template>

<script>
import incomeEnsure from '@/views/adOrder/income_summary/ensure_income/list.vue'
import incomeBusiness from '@/views/adOrder/income_summary/business_income/index.vue'
import incomeSummaryV2 from '@/views/adOrder/income_summary/income_summary_v2/list.vue'

const permissions = localStorage.getItem('userAuth') ? JSON.parse(localStorage.getItem('userAuth')).value : {}
const {ensure_income__list, business_income__list, income_summary_v2__list} = permissions

export default {
  name: "index",
  data() {
    return {
      activeName: null,
    }
  },
  components: {
    incomeEnsure,
    incomeBusiness,
    incomeSummaryV2,
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleChange(tabName) {
      // eslint-disable-next-line no-console
      // console.log(this.activeName)
    }
  },
  created() {
    const tabRange = []
    if (ensure_income__list) {
      // this.activeName = '全案保量'
      tabRange.push('全案保量')
    }
    if (business_income__list) {
      // this.activeName = '商务收入'
      tabRange.push('商务收入')
    }
    if (income_summary_v2__list) {
      // this.activeName = '收入汇总V2'
      tabRange.push('收入汇总V2')
    }
    // eslint-disable-next-line no-console
    const query = this.$route.query
    // eslint-disable-next-line no-console
    console.log(query.tab)
    if (query.tab) {
      if (tabRange.indexOf[query.tab] > -1) {
        this.activeName = query.tab
      }
    } else {
      this.activeName = tabRange[0] || null
    }


  }
}
</script>

<style scoped>

</style>
